<div class="wrap">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.45)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
        <p style="color: #fff">Generating report...</p>
    </ngx-spinner>
    <app-header></app-header>
        <div class="main-holder">
            <app-nav></app-nav>
            <div class="main">
                <div class="main-content">
                    <div class="bread">
                        <ol>
                            <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                            <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                            <li><span>Customers</span></li>
                        </ol>
                    </div>
                    <div class="content-title">
                        <h2>Customers</h2>
                    </div>
                    <hr>
                    <div class="cards">
                        <div class="row">
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Verified Customers</small>
                                        <h4>{{ this.userOverview['totalVerified'] }}</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/verified.svg">
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Pending Registration</small>
                                        <h4>{{ this.userOverview['totalUnVerified'] }}</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/users.svg">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cards">
                        <div class="row">
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Booked 2-wheels Express</small>
                                        <h4>{{ this.userOverview['expressTwoWheelsCount'] }}</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/riders.svg">
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Booked 2-wheels MotoTaxi</small>
                                        <h4>{{ this.userOverview['rideHailingTwoWheelsCount'] }}</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/riders.svg">
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Booked 4-wheels Express</small>
                                        <h4>{{ this.userOverview['expressFourWheelsCount'] }}</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/supply.svg">
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Booked 4-wheels Ride</small>
                                        <h4>{{ this.userOverview['rideHailingFourWheelsCount'] }}</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/supply.svg">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="list-holder">
                        <div class="tools">
                            <div class="search mg-right-auto">
                                <img src="../../../../assets/okito/images/icons/magnifying.svg">
                                <input (input)="searchData($event)" [(ngModel)]="this.searchKeyword" type="text" class="text-search"
                                    placeholder="Search">
                            </div>
                            <div class="search mg-right-auto" style="width:58%;">
                                <span style="font-weight:bold;margin-right:5px;">Sorting: </span>
                                <select class="form-select" style="width:30%;margin-right:10px;" [(ngModel)]="userSortBy"
                                    (ngModelChange)="onSortChange()">
                                    <option value="name">Name</option>
                                    <option value="email">Email</option>
                                    <option value="dateCreated">Date Created</option>
                                    <option value="status">Status</option>
                                </select>

                                <div class="btn-group" role="group" aria-label="Sort by.." style="width:5%;">
                                    <button type="button" [ngClass]="{'active': userSortDirection === 'asc'}" class="btn btn-secondary"
                                        (click)="userSortDirection = 'asc'; onSortChange()">Ascending</button>
                                    <button type="button" [ngClass]="{'active': userSortDirection === 'desc'}" class="btn btn-secondary"
                                        (click)="userSortDirection = 'desc'; onSortChange()">Descending</button>
                                </div>
                            </div>
                            <div class="actions">
                                <button class="btn btn-sm btn-default" (click)="downloadCustomersReport()" [disabled]="isDownloadingReport">
                                    <i class="fa fa-download"></i>&nbsp;Download
                                </button>
                            </div>
                        </div>
                        <div class="list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Customer ID</th>
                                        <th>Name</th>
                                        <th>Mobile Number</th>
                                        <th>Email</th>
                                        <th>Date Created</th>
                                        <th>Current Pts</th>
                                        <th>Used Pts</th>
                                        <th>Total Pts</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="currentSelectedPageList.length != 0; else noRecordsMain">
                                        <tr *ngFor="let consumer of this.currentSelectedPageList">
                                            <td>{{ consumer.membershipId }}</td>
                                            <td>{{ consumer.name }}</td>
                                            <td>{{ consumer.mobile }}</td>
                                            <td>{{ consumer.email }}</td>
                                            <td>{{ consumer.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A' }}</td>
                                            <td>{{ consumer.currentPoints | number: '1.2-2'}}</td>
                                            <td>{{ consumer.usedPoints | number: '1.2-2' }}</td>
                                            <td>{{ consumer.usedPoints + consumer.currentPoints | number: '1.2-2' }}</td>
                                            <td>
                                                <span [ngClass]="(consumer.isVerify) ? 'stat stat-active' : 'stat stat-pending'">{{
                                                    (consumer.isVerify) ? 'ACTIVE' :
                                                    'PENDING' }}</span>
                                            </td>
                                            <td><a (click)="viewDetails(consumer)" style="cursor: pointer;">View</a></td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #noRecordsMain>
                                        <tr>
                                            <td colspan="10" class="no-records-msg">
                                                <h6 class="ponds-contents-med-bold">No records found</h6>
                                            </td>
                                        </tr>
                                    </ng-template>

                                </tbody>
                            </table>
                        </div>
                        <div class="list-footer">
                            <div class="pager">
                                <button class="pager-prev" (click)="nextPrev('prev')"><img src="../../../../assets/okito/images/icons/prev.svg"></button>
                                <button class="pager-next" (click)="nextPrev('next')"><img src="../../../../assets/okito/images/icons/next.svg"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>
